import { combineReducers, configureStore } from '@reduxjs/toolkit';
import analyticsSlice from "./slices/analytics.slice";
import appStateSlice from "./slices/appState.slice";
import builderSlice from "./slices/builder.slice";
import { comparisonReducer } from "./slices/comparison.slice";
import comparisonV2Slice from "./slices/comparisonV2.slice";
import contentGroupsSlice from "./slices/contentGroups.slice";
import gptApiSlice from './slices/gpt.slice.js';
import largeDataAnalyticsSlice from "./slices/largeDataAnalytics.slice";
import portfoliosSlice from "./slices/portfolios.slice";
import prospectsSlice from "./slices/prospects.slice";
import publicSlice from "./slices/public.slice";
import resourcesSlice from "./slices/resources.slice";
import smaSlice from "./slices/sma.slice";
import superuserSlice from "./slices/superUser.slice";
import timeseriesSlice from "./slices/timeseries.slice";
import timeseriesModelsSlice from "./slices/timeseriesModels.slice";
import tickersSlice from "./slices/tickers.slice";
import userSlice from "./slices/user.slice";
import clientJourneySlice from "./slices/clientJourney.slice";
import globalResourcesSlice from "./slices/globalResources.slice";

const reducer = combineReducers({
  analytics: analyticsSlice,
  appStates: appStateSlice,
  builder: builderSlice,
  comparison: comparisonReducer,
  comparisonV2: comparisonV2Slice,
  contentGroups: contentGroupsSlice,
  clientJourney: clientJourneySlice,
  global: globalResourcesSlice,
  gptApi: gptApiSlice,
  largeDataAnalytics: largeDataAnalyticsSlice,
  public: publicSlice,
  prospects: prospectsSlice,
  portfolios: portfoliosSlice,
  resources: resourcesSlice,
  sma: smaSlice,
  superuser: superuserSlice,
  tickers: tickersSlice,
  timeSeries: timeseriesSlice,
  timeSeriesModels: timeseriesModelsSlice,
  user: userSlice,

});


const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}),
  devTools: process.env.NODE_ENV === 'development',
});

export default store;
